const key = "security-exception";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/[0-9]+\/security$/);
};

const modify = () => {
	throw new Error("Mock error on security endpoint");
};

export const securityException = [key, applicable, modify];